<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->

      <b-link class="brand-logo d-none d-lg-flex align-items-center">
        <b-img
          :src="require('@/assets/images/logo/secondary-logo.png')"
          class="rounded mr-2"
          height="50"
          width="150"
          alt="Toast image"
        />
      </b-link>
      <!-- /Brand logo-->
      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Welcome to FlyGate portal
          </b-card-title>
          <!-- form -->
          <validation-observer
            v-if="isForgotPassword === false"
            ref="loginForm"
            #default="{ invalid }"
          >
            <b-card-text class="mb-2" v-if="!isFirstLogin">
              Please sign-in to your account and start the adventure
            </b-card-text>
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              <!-- email -->
              <b-form-group
                v-if="!isFirstLogin"
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="form.username"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group
                v-if="!isFirstLogin"
                label="Password"
                label-for="login-password"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="form.password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Sign in
              </b-button>
              <div class="d-flex justify-content-end pt-1">
                <b-link @click="forgotPasswordFunction()">
                  Forgot Password?
                </b-link>
              </div>
            </b-form>
          </validation-observer>

          <validation-observer
            v-if="isForgotPassword === true"
            ref="ForgotForm"
            #default="{ invalid }"
          >
            <b-card-text class="mb-2">
              Please enter your email to get a password recovery link.
            </b-card-text>
            <b-form
              class="auth-forgot-form mt-2"
              @submit.prevent="forgotPassword"
            >
              <!-- email -->
              <b-form-group label="Email" label-for="forgot-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="forgot-email"
                    v-model="forgotForm.username"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <b-form-group>
                <validation-provider
                  #default="{ errors }"
                  name="recaptcha"
                  vid="recaptcha"
                  rules="required"
                >
                  <vue-recaptcha
                    ref="recaptcha"
                    v-model="recaptcha"
                    :sitekey="siteKey"
                    @verify="mxVerify"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Send Link
              </b-button>
            </b-form>
            <a class="text-primary" @click="backToLoginFunction()">
              <small>Back to Login</small>
            </a>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <!-- <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div> -->

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
      <!-- /Login-->

      <!-- loadings -->
      <b-overlay
        class="d-flex justify-content-center"
        :show="isLoading"
        no-wrap
        rounded="sm"
      >
        <template #overlay>
          <div id="loading-bg">
            <div class="loading-logo">
              <img src="../../../public/logo.png" alt="Please Wait..." />
            </div>
          </div>
        </template>
      </b-overlay>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueRecaptcha } from "vue-recaptcha";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BOverlay,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  VBTooltip,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import store from "@/store/index";
// import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import useJwt from "@/auth/jwt/useJwt";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { setAuthenticated } from "@/router";

export default {
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    VueRecaptcha,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      SERVICE_KEY: process.env.VUE_APP_SERVICE_KEY,
      siteKey: "6Len0LgpAAAAALQJmv8fyVHggHy8s5On5muoJSs6",
      recaptcha: null,
      isLoading: false,

      form: {
        username: "",
        password: "",
      },
      forgotForm: {
        username: "",
      },
      isForgotPassword: false,
      status: "",
      isFirstLogin: false,
      sideImg: require("@/assets/images/pages/new-banner.svg"),
      // validation rules
      required,
      email,
    };
  },

  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === "dark") {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require("@/assets/images/pages/new-banner.svg");
        // this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg;
      }
      return this.sideImg;
    },
  },
  methods: {
    mxVerify(response) {
      this.recaptcha = response;
    },
    forgotPasswordFunction() {
      this.isForgotPassword = true;
    },
    backToLoginFunction() {
      this.isForgotPassword = false;
    },
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line no-undef
          this.isLoading = true;
          axios
            .post("/api/V1.0/Token/GetToken", {
              serviceKey: this.SERVICE_KEY,
            })
            .then((res) => {
              axios
                .post("/User/api/V1.0/Account/SignIn", this.form)
                .then((response) => {
                  if (response.requires2FA) {
                    this.isLoading = false;
                    this.$router.replace({
                      name: "auth-otp-verification",
                      params: {
                        tempToken: response.tempToken,
                        message: response.message,
                        form: this.form,
                      },
                    });
                  } else {
                    setAuthenticated();
                    this.isLoading = false;
                    window.location.href = "/";
                  }
                })
                .catch((error) => {
                  console.log(error);
                  if (error.data.isFirstLogin) {
                    this.isFirstLogin = error.data.isFirstLogin;
                    this.$router.push(
                      {
                        name: "auth-password-reset-firstLogin",
                        params: {
                          id: this.form.username,
                          isFirstLogin: this.isFirstLogin,
                        },
                      },
                      "/password-reset-firstLogin",
                    );
                    this.isLoading = false;
                    this.$toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        title: "First Login",
                        icon: "BellIcon",
                        variant: "warning",
                        text: `${error.data.message}`,
                      },
                    });
                  } else {
                    this.isLoading = false;
                    this.$toast({
                      component: ToastificationContent,
                      position: "top-right",
                      props: {
                        title: "Error",
                        icon: "BellIcon",
                        variant: "danger",
                        text: `${error.data.message}`,
                      },
                    });
                  }
                });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${error.data.message}`,
                },
              });
            });
        }
      });
    },

    forgotPassword() {
      this.$refs.ForgotForm.validate().then((success) => {
        if (success) {
          // eslint-disable-next-line no-undef
          this.$store.dispatch("config/getActionPrivilege", "Account-SignIn");
          this.isLoading = true;
          axios
            .post("/api/V1.0/Token/GetToken", {
              serviceKey: this.SERVICE_KEY,
            })
            .then((res) => {
              axios
                .post("/User/api/V1.0/Password/ForgotPassword", this.forgotForm)
                .then((response) => {
                  this.$toast({
                    component: ToastificationContent,
                    props: {
                      title: `${response.message}`,
                      icon: "BellIcon",
                      variant: "success",
                      text: ``,
                    },
                  });
                  this.isLoading = false;
                })
                .catch((error) => {
                  this.isLoading = false;
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: `${error.data.message}`,
                      icon: "BellIcon",
                      variant: "warning",
                      text: ``,
                    },
                  });
                });
            })
            .catch((error) => {
              console.log(`Error msg: ${error}`);
              this.$toast({
                component: ToastificationContent,
                position: "top-right",
                props: {
                  title: "Error",
                  icon: "BellIcon",
                  variant: "danger",
                  text: `${error.data.message}`,
                },
              });
            });
        }
      });
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
